import { FC, useMemo } from 'react'
import { useFormState } from 'react-final-form'
import { Divider } from '@cargomart/ui'
import MapPointAIcon from 'assets/map-point-a.svg?react'
import MapPointBIcon from 'assets/map-point-b.svg?react'
import { groupBy } from 'lodash'
import { OrderYarcheCreateCargo } from 'schema'

import { useGetAllYarcheTerminalsQuery } from '../api'
import { useYarcheDestinationDate } from '../hooks'
import { OrderYarcheCreateFormData } from '../pages/OrderYarcheCreatePage/types'
import OrderYarcheCreateSummaryCargo from './OrderYarcheCreateSummaryCargo'
import OrderYarcheCreateSummaryDeliveryDate from './OrderYarcheCreateSummaryDeliveryDate'
import OrderYarcheCreateSummaryTotalPrice from './OrderYarcheCreateSummaryTotalPrice'

interface OrderYarcheCreateSummaryProps {
  className?: string
}

const OrderYarcheCreateSummary: FC<OrderYarcheCreateSummaryProps> = ({ className }) => {
  const { values } = useFormState<OrderYarcheCreateFormData>()
  const { departurePoint, destinationPoint, cargo } = values
  const { deliveryDate, isLoading } = useYarcheDestinationDate({ departurePoint, destinationPoint })

  const { data: terminals } = useGetAllYarcheTerminalsQuery('')
  const teminalsById = useMemo(() => groupBy(terminals, 'id'), [terminals])

  const [destinationTerminal, departureTerminal] = useMemo(() => {
    if (!Object.keys(teminalsById).length) {
      return [null, null]
    }

    return [
      departurePoint?.terminalId ? teminalsById[departurePoint.terminalId][0] : null,
      destinationPoint?.terminalId ? teminalsById[destinationPoint.terminalId][0] : null
    ]
  }, [teminalsById, departurePoint, destinationPoint])

  return (
    <div className={className}>
      <div className="text-headline-sm">Предварительный расчёт</div>
      <div className="py-6">
        <div className="mb-2 flex gap-1 text-body-md">
          <MapPointAIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
          <div>{destinationTerminal?.address || '—'}</div>
        </div>
        <div className="flex gap-1 text-body-md">
          <MapPointBIcon className="text-on-surface-variant" containerSize="sm" size="xs" />
          <div>{departureTerminal?.address || '—'}</div>
        </div>
        <Divider className="my-1" />
        <OrderYarcheCreateSummaryCargo cargo={cargo as OrderYarcheCreateCargo} />
        <OrderYarcheCreateSummaryDeliveryDate deliveryDate={deliveryDate?.deliveryDate} isLoading={isLoading} />
        <Divider className="my-1" />
        <OrderYarcheCreateSummaryTotalPrice />
      </div>
    </div>
  )
}

export default OrderYarcheCreateSummary
